import React, { useState, useEffect } from "react";
import Link from "next/link";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useRouter } from "next/router";
import Carousel from "react-bootstrap/Carousel";
import LazyImage from "../../molecules/layout/Images/LazyImage";
import { recordPlanSave } from "../../../utils/analytics/plans";
import {
    addSavedPlan,
    removeSavedPlan,
} from "../../../state/actions/plans/plans";
// import getImageUrlWithCdnPrefix from "../../../utils/getImageUrlWithCdnPrefix";
import rgbDataURL from "../../../utils/rgbDataURL";
import Image from "@image";

function ImageCarousel({
    images,
    planName,
    house_type,
    bedrooms,
    bathrooms,
    priority,
}) {
    return (
        <div>
            <Carousel
                controls={false}
                interval={Math.floor(Math.random() * 10000) + 20000}
            >
                {images.map((imgObj) => (
                    <Carousel.Item key={imgObj.id}>
                        {imgObj.image ? (
                            // image
                            // imgObj.image.file &&
                            // imgObj.image.file.startsWith("http") ? (
                            //     <LazyImage
                            //         height={300}
                            //         width={500}
                            //         className="d-block img-fluid card-img-top rounded-top"
                            //         src={imgObj.image.file}
                            //         alt={`${planName} - ${imgObj.image.title} from Inuua Tujenge house plans with ${bedrooms} bedrooms and ${bathrooms} bathrooms. ( ${house_type} )`}
                            //     />
                            // ) : (
                            <Image
                                height={300}
                                width={500}
                                layout="responsive"
                                className="d-block img-fluid card-img-top rounded-top"
                                quality={20}
                                placeholder="blur"
                                blurDataURL={rgbDataURL()}
                                src={imgObj.image.file}
                                priority={priority}
                                alt={`${planName} - ${imgObj.image.title} from Inuua Tujenge house plans with ${bedrooms} bedrooms and ${bathrooms} bathrooms. ( ${house_type} )`}
                            />
                        ) : // )
                        // )
                        // end image
                        null}
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    );
}

function PlanCard(props) {
    const [savedPlan, setSavedPlan] = useState(false);
    const router = useRouter();

    // check if saved plan
    useEffect(() => {
        const isObjectPresent = props.savedPlans.find(
            (obj) => obj.building_plan.id == props.id
        );

        if (!isObjectPresent) {
            setSavedPlan(false);
        } else {
            setSavedPlan(true);
        }
    }, [props.id, props.savedPlans]);

    function handleSavePlan() {
        if (!props.isAuthenticated) {
            return router.push({
                pathname: "/accounts/login",
                query: { next: router.asPath },
            });
        }

        if (
            !(
                props.getSavedPlansLoading ||
                props.addSavedPlanLoading ||
                props.removeSavedPlanLoading
            )
        ) {
            if (savedPlan) {
                props.removeSavedPlan(props.id);
            } else {
                props.addSavedPlan(props.id);
                recordPlanSave(
                    props.id,
                    props.name,
                    props.slug,
                    props.plan_identifier,
                    props.house_type,
                    props.bedrooms,
                    props.bathrooms,
                    props.cost,
                    props.show_calculated_cost,
                    props.minimum_plot_size
                );
            }
        }
    }

    return (
        <div id={props.slug} className="col-12 col-lg-4 mb-5">
            <div className="card shadow-soft border-light">
                <div className="card-header p-0 custom-header-img">
                    <ImageCarousel
                        images={props.images}
                        planName={props.name}
                        house_type={props.house_type}
                        bedrooms={props.bedrooms}
                        bathrooms={props.bathrooms}
                        priority={
                            props.priorityImage ? props.priorityImage : false
                        }
                    />
                </div>
                <Link
                    href={`${props.planPath ? props.planPath : "/plans/plan"}/${
                        props.slug
                    }`}
                >
                    <a>
                        <div className="card-body pt-2 pb-0">
                            <div className="pl-0 pt-1">
                                <span className="text-gray-700">
                                    Build cost&nbsp;
                                </span>
                                <span className="text-dark font-small font-weight-bold">
                                    KSh {props.cost.toLocaleString()}
                                </span>
                            </div>
                            <div className="pl-0 pt-1">
                                <span className="font-medium font-weight-bold text-dark">
                                    {props.name}
                                </span>
                            </div>
                            <div className="pl-0">
                                <ul className="list-inline">
                                    <li className="list-inline-item mr-4 text-gray-700">
                                        <i className="fas fa-bed font-smal font-weight-bold"></i>
                                        &nbsp;
                                        <span>
                                            <small>{props.bedrooms}</small>
                                        </span>
                                    </li>
                                    <li className="list-inline-item mr-4 text-gray-700">
                                        <i className="fas fa-bath font-smal font-weight-bold"></i>
                                        &nbsp;
                                        <span>
                                            <small>{props.bathrooms}</small>
                                        </span>
                                    </li>
                                    {props.minimum_plot_size && (
                                        <li className="list-inline-item mr-4 text-gray-700">
                                            <i className="fas fa-ruler-combined font-small font-weight-bold"></i>
                                            &nbsp;
                                            <span>
                                                <small>
                                                    {props.minimum_plot_size}{" "}
                                                    and above
                                                </small>
                                            </span>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </a>
                </Link>
                <hr className="mt-0 mb-2" />
                <div className="d-flex align-items-end">
                    <p
                        className={`flex-grow-1 text-center ${
                            props.getSavedPlansLoading ||
                            props.addSavedPlanLoading ||
                            props.removeSavedPlanLoading
                                ? "text-light"
                                : ""
                        }`}
                        onClick={handleSavePlan}
                    >
                        <a>
                            {savedPlan ? "Plan saved" : "Save plan"}{" "}
                            <i
                                className={`${
                                    savedPlan ? "fas fa-heart" : "far fa-heart"
                                } ml-2`}
                            />
                        </a>
                    </p>
                    <Link
                        href={`${
                            props.planPath ? props.planPath : "/plans/plan"
                        }/${props.slug}`}
                    >
                        <p className="flex-grow-1 text-center">
                            <a>
                                More details{" "}
                                <i className="fas fa-arrow-right ml-2" />
                            </a>
                        </p>
                    </Link>
                </div>
            </div>
        </div>
    );
}

PlanCard.propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    plan_identifier: PropTypes.string.isRequired,
    house_type: PropTypes.string.isRequired,
    bedrooms: PropTypes.number.isRequired,
    bathrooms: PropTypes.number.isRequired,
    cost: PropTypes.number.isRequired,
    show_calculated_cost: PropTypes.bool.isRequired,
    minimum_plot_size: PropTypes.string.isRequired,
    //
    isAuthenticated: PropTypes.bool.isRequired,
    //
    addSavedPlan: PropTypes.func.isRequired,
    removeSavedPlan: PropTypes.func.isRequired,
    getSavedPlansLoading: PropTypes.bool.isRequired,
    savedPlans: PropTypes.arrayOf(PropTypes.object).isRequired,
    addSavedPlanLoading: PropTypes.bool.isRequired,
    removeSavedPlanLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
    isAuthenticated: state.authReducer.isAuthenticated,
    //
    getSavedPlansLoading: state.plansReducer.getSavedPlansLoading,
    savedPlans: state.plansReducer.savedPlans,
    addSavedPlanLoading: state.plansReducer.addSavedPlanLoading,
    removeSavedPlanLoading: state.plansReducer.removeSavedPlanLoading,
});

const mapDispatchToProps = {
    addSavedPlan,
    removeSavedPlan,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanCard);

/*
{
    id: 153,
    images: [
        {
            id: 265,
            sort_order: 0,
            building_plan: 153,
            image: 861,
        },
    ],
    name: "4 Bedroom Bungalow-ID 4154",
    slug: "4-bedroom-bungalow-id-4154",
    plan_identifier: "4154",
    is_public: true,
    date_created: "2020-10-01T12:21:02.793270+03:00",
    description:
        "<p></p><p>A modern look, yet a practical plan with secluded living areas for this popular 4 bed room home</p>",
    house_type: "bungalow",
    bedrooms: 4,
    bathrooms: 2,
    floor_area: 161.0,
    plot_area: 100.0,
    width: "30.00",
    length: "60.00",
    plan_price: "20000.00",
    cost: 5489202,
    show_calculated_cost: true,
    ratings_score: null,
    minimum_plot_size: "30x60",
    product: 131,
}
*/
